module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-19.b0ea9df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-19.jpg
// module id = xWOA
// module chunks = 51